import { defineComponent as n, computed as t, openBlock as h, createElementBlock as i, createElementVNode as e, toDisplayString as r, createCommentVNode as a, normalizeStyle as f } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ e("mask", { id: "faeafdd1-9e23-420b-87f7-e01ce152d77d" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#faeafdd1-9e23-420b-87f7-e01ce152d77d)" }, v = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h512v256.2l-41.9 64.3 41.9 63.7V512H0V384.2L41.3 320 0 256.2z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 256.2h512v42.9l-15.7 21.6 15.7 21v42.5H0v-42.5l15.1-21.5L0 299z"
}, null, -1), z = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 299.1h512v42.6H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m182.8 190.4 5.2 16.4h17.1l-13.8 10 5.3 16.3-13.8-10-14 10 5.4-16.3-13.9-10h17.1zm0 213.3L188 420h17.1l-13.8 10 5.3 16.2-13.8-10-14 10L174 430l-14-10h17.2zm-99.2-72.1 5.2 16.2h17.1L92.1 358l5.2 16.2-13.7-10-14 10L75 358l-14-10.1h17.2zm37.9-119.8 5 16h17.2l-13.8 10.3 5.2 16.2-13.7-10-14 10 5.4-16.3-14-10.1H116zm-60.4 67h17l5.5-16.2 5.2 16.2h17.1L92.1 289l5.2 16.4L83.6 295l-14 10.3 5.4-16.4zm46.5 143 5.3-16.2L99 395.4h17.1l5.4-16.2 5.2 16.3h17.1L130 405.6l5.3 16.2-13.8-10zM282 331.6l-5.4 16.2h-17l13.8 10.2-5.3 16.2 13.9-10 13.8 10-5.2-16.3 13.7-10.1h-17zm-38-119.8-5.3 16.2h-17.1l14 10.2-5.4 16.2 13.9-10 13.8 10-5.3-16.3 13.8-10.1h-17zm60.3 67h-17l-5.3-16.2-5.4 16.2h-17l13.8 10.1-5.3 16.4L282 295l13.8 10.3-5.2-16.4zm-46.4 143-5.3-16.2 13.8-10.2h-17l-5.3-16.2-5.4 16.3h-17.1l14 10.1-5.4 16.2 13.9-10z"
}, null, -1), L = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ n({
  __name: "cv",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const l = c, o = t(() => 512 + 2 * l.strokeWidth), s = t(() => -l.strokeWidth), d = t(() => 256 + l.strokeWidth / 2);
    return (w, y) => (h(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      _,
      e("g", u, [
        l.flagName ? (h(), i("title", v, r(l.flagName), 1)) : a("", !0),
        p,
        k,
        z,
        g
      ]),
      e("g", L, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: f({ stroke: l.strokeColor, strokeWidth: l.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  B as default
};
//# sourceMappingURL=cv-587cbe53.js.map
